import { Action, action, Computed, computed } from "easy-peasy";
import { ExternalAccount, TransferDirection } from "../../types";

export type EmployeeTransferStep =
  | "SEND_WARNING"
  | "SELECT_ACCOUNT"
  | "SELECT_AMOUNT"
  | "REVIEW_TRANSFER"
  | "TWO_FACTOR_VERIFICATION"
  | "TRANSFER_INITIATED";
export const ADD_MONEY_STEPS: EmployeeTransferStep[] = [
  "SELECT_ACCOUNT",
  "SELECT_AMOUNT",
  "REVIEW_TRANSFER",
  "TWO_FACTOR_VERIFICATION",
  "TRANSFER_INITIATED",
];
export const SEND_MONEY_STEPS: EmployeeTransferStep[] = [
  "SEND_WARNING",
  "SELECT_ACCOUNT",
  "SELECT_AMOUNT",
  "REVIEW_TRANSFER",
  "TWO_FACTOR_VERIFICATION",
  "TRANSFER_INITIATED",
];

interface EmployeeTransferStateProps {
  currentStep: EmployeeTransferStep;
  previousStep: Computed<EmployeeTransferModel, EmployeeTransferStep>;
  nextStep: Computed<EmployeeTransferModel, EmployeeTransferStep>;
  externalAccount: ExternalAccount | null;
  amount: string | null;
  direction: TransferDirection;
  // this is the id of the ach transfer that is created
  createdTransferId: number | null;
}

export interface EmployeeTransferModel extends EmployeeTransferStateProps {
  setCurrentStep: Action<EmployeeTransferModel, EmployeeTransferStep>;
  setExternalAccount: Action<EmployeeTransferModel, ExternalAccount>;
  setAmount: Action<EmployeeTransferModel, string>;
  setDirection: Action<EmployeeTransferModel, TransferDirection>;
  resetState: Action<EmployeeTransferModel>;
  setCreatedTransferId: Action<EmployeeTransferModel, number>;
}

const initialState: EmployeeTransferStateProps = {
  currentStep: "SEND_WARNING",
  previousStep: computed((state) => {
    if (state.direction === "add_money") {
      const stepIndex = ADD_MONEY_STEPS.indexOf(state.currentStep) - 1;
      return ADD_MONEY_STEPS[stepIndex];
    } else {
      const stepIndex = SEND_MONEY_STEPS.indexOf(state.currentStep) - 1;
      return SEND_MONEY_STEPS[stepIndex];
    }
  }),
  nextStep: computed((state) => {
    if (state.direction === "add_money") {
      const stepIndex = ADD_MONEY_STEPS.indexOf(state.currentStep) + 1;
      return ADD_MONEY_STEPS[stepIndex];
    } else {
      const stepIndex = SEND_MONEY_STEPS.indexOf(state.currentStep) + 1;
      return SEND_MONEY_STEPS[stepIndex];
    }
  }),
  externalAccount: null,
  amount: null,
  direction: "send_money",
  createdTransferId: null,
};

export const transfer: EmployeeTransferModel = {
  ...initialState,
  setCurrentStep: action((state, payload: EmployeeTransferStep) => {
    state.currentStep = payload;
  }),
  setExternalAccount: action((state, payload: ExternalAccount) => {
    state.externalAccount = payload;
  }),
  setAmount: action((state, payload: string) => {
    state.amount = payload;
  }),
  setDirection: action((state, payload: TransferDirection) => {
    state.direction = payload;
  }),
  resetState: action((state) => {
    Object.assign(state, initialState);
  }),
  setCreatedTransferId: action((state, payload: number) => {
    state.createdTransferId = payload;
  }),
};
